import R from 'app/assets/R'
import { IRefModal } from 'app/components/common/ModalComponent'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { notificationController } from 'app/controllers/notification-controller'
import { useUpdateActivityEngagement } from 'app/react-query/hook/activityEngagement'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { IPayloadUpdateActivityEngagement, IProps } from './type'

export const useHook = ({ activityEngagement }: IProps) => {
  const { t } = useTranslation()
  const [form] = BaseForm.useForm<IPayloadUpdateActivityEngagement>()
  const modalRef = useRef<IRefModal>({})

  const { mutateAsync: mutateAsyncUpdate, isLoading } =
    useUpdateActivityEngagement()

  useEffect(() => {
    form?.setFieldsValue({
      name: activityEngagement?.name,
      description: activityEngagement?.description,
      code: activityEngagement.code,
    })
  }, [activityEngagement])

  const handleSubmit = async (values: IPayloadUpdateActivityEngagement) => {
    const newAccount: IPayloadUpdateActivityEngagement = {
      id: activityEngagement?.id,
      name: values?.name,
      description: values?.description,
      code: values?.code,
    }

    await mutateAsyncUpdate?.(newAccount)
    modalRef?.current?.hide?.()
    form?.resetFields()
    notificationController.success({
      message: t(R.strings.success),
    })
  }

  return {
    form,
    modalRef,
    handleSubmit,
    isLoading,
  }
}
